var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNav7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_1740_7980)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 2H12C13.9422 2 15.1976 2.00425 16.1226 2.12861C16.9901 2.24524 17.262 2.43354 17.4142 2.58579C17.5665 2.73803 17.7548 3.00993 17.8714 3.87741C17.9958 4.80242 18 6.05784 18 8V12C18 13.9422 17.9958 15.1976 17.8714 16.1226C17.7548 16.9901 17.5665 17.262 17.4142 17.4142C17.288 17.5405 17.0794 17.6915 16.5172 17.8059C16.0358 16.7516 15.2226 15.8502 14.1913 15.1907C12.9724 14.4114 11.4994 14 10 14C8.50065 14 7.02756 14.4114 5.80871 15.1907C4.77744 15.8502 3.96415 16.7516 3.48277 17.8059C2.92057 17.6915 2.71204 17.5405 2.58579 17.4142C2.43354 17.262 2.24524 16.9901 2.12861 16.1226C2.00425 15.1976 2 13.9422 2 12V8C2 6.05784 2.00425 4.80242 2.12861 3.87741C2.24524 3.00993 2.43354 2.73803 2.58579 2.58579C2.73803 2.43354 3.00993 2.24524 3.87741 2.12861C4.80242 2.00425 6.05784 2 8 2ZM5.6859 17.9853C6.33097 17.9991 7.09012 18 8 18H12C12.9099 18 13.669 17.9991 14.3141 17.9853C14.0093 17.5692 13.6065 17.1908 13.1139 16.8757C12.237 16.315 11.1423 16 10 16C8.85774 16 7.76304 16.315 6.88615 16.8757C6.39346 17.1908 5.9907 17.5692 5.6859 17.9853ZM0 8C0 4.22876 0 2.34315 1.17157 1.17157C2.34315 0 4.22876 0 8 0H12C15.7712 0 17.6569 0 18.8284 1.17157C20 2.34315 20 4.22876 20 8V12C20 15.7712 20 17.6569 18.8284 18.8284C17.6569 20 15.7712 20 12 20H8C4.22876 20 2.34315 20 1.17157 18.8284C0 17.6569 0 15.7712 0 12V8ZM10 6C8.89543 6 8 6.89543 8 8C8 9.10457 8.89543 10 10 10C11.1046 10 12 9.10457 12 8C12 6.89543 11.1046 6 10 6ZM6 8C6 5.79086 7.79086 4 10 4C12.2091 4 14 5.79086 14 8C14 10.2091 12.2091 12 10 12C7.79086 12 6 10.2091 6 8Z",
    fill: "#9B9B9B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1740_7980",
    x: 0,
    y: 0,
    width: 20.3333,
    height: 20.3333,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.333328,
    dy: 0.333328
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.666656
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.19534 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1740_7980"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNav7);
export default __webpack_public_path__ + "static/media/nav7.c73a8dcf354b076819f66d980f17aeaa.svg";
export { ForwardRef as ReactComponent };